import { Input } from '@avanta/shared/components/ui/Input';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDebounce } from '@avanta/shared/hooks/useDebounce';
import { useFetchSearchPsychologist } from '@avanta/shared/hooks/useFetchSearchPsychologist';
import { type Psychologist } from '@avanta/shared/types/psychologists';
import { Search } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SEARCH_PSYCHOLOGISTS_KEY_PREFIX } from '..';
import { BackButton } from '../../../../ui/BackButton';
import { PsychoCard } from '../../../../ui/PsychoCard';
import { StepSection } from '../../../../ui/StepSection';
import { MobileViewSkeleton } from './Skeleton';

export const MobileView = ({
  handleOnClick,
  handleOnBack,
}: {
  handleOnClick: (psychologist: Psychologist) => void;
  handleOnBack: () => void;
}): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search);
  const { data: psychologists = [], isLoading } = useFetchSearchPsychologist({
    name: debouncedSearch,
  });

  return (
    <div className="am-lg:hidden flex flex-col gap-4 pb-4">
      <StepSection
        title={t(`${SEARCH_PSYCHOLOGISTS_KEY_PREFIX}title`)}
        className="w-full flex flex-col min-h-0 gap-4"
        containerClassName="relative w-full"
        fullWidth
      >
        <Input
          placeholder={t(`${SEARCH_PSYCHOLOGISTS_KEY_PREFIX}search.placeholder`)}
          leftIcon={Search}
          onChange={e => setSearch(e.target.value)}
        />
        {isLoading ? (
          <MobileViewSkeleton />
        ) : (
          psychologists.map(psychologist => (
            <PsychoCard
              key={psychologist.id}
              psychologist={psychologist}
              onClick={() => handleOnClick(psychologist)}
            />
          ))
        )}
      </StepSection>
      <BackButton handleBack={handleOnBack} className="mt-4" />
    </div>
  );
};
